import { ReactElement } from "react";
import { CatTab } from '@blocks-react/components/Tab';


declare interface TabProps {
  href?: number,
  ariaLabelledBy: string
}

interface MyEquipmentTabProps {
  children: ReactElement | string;
  tabProps: TabProps
}

export const MyEquipmentTab = ({
  children,
  ...tabProps
}: MyEquipmentTabProps) => {

  return (
    <CatTab
    {...tabProps}
  >
    {children}
  </CatTab>
  );
};
